import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'

import AppsumoPlans from 'components/account/AppsumoPlans'

import appsumoActions from 'store/modules/appsumo'
import userSelectors from 'store/selectors/user'
import snackbarActions from '@nocode-works/template/store/modules/snackbar'
import routerActions from '@nocode-works/template/store/modules/router'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(4),
  },
  paddedRow: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}))

const Welcome = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const userData = useSelector(userSelectors.data)

  useEffect(() => {
    dispatch(snackbarActions.setSuccess(`Your AppSumo account has been activated!`))
  }, [])

  useEffect(() => {
    dispatch(appsumoActions.loadPlans())
  }, [])

  return (
    <div className={ classes.root }>
      <Container maxWidth="md">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper className={ classes.paper }>
              <Typography variant="h4" gutterBottom>
                nocode activated!
              </Typography>
              <Typography gutterBottom variant="body1">
                You have activated your AppSumo nocode account!
              </Typography>
              <div className={ classes.paddedRow }>
                <Alert severity="info">AppSumo account: <strong>{ userData.appsumo_email }</strong></Alert>
              </div>
              <Typography gutterBottom variant="body1">
                You can now start to create websites!
              </Typography>
              <Button
                className={ classes.paddedRow }
                size="small"
                color="secondary"
                variant="contained"
                onClick={ () => {
                  dispatch(routerActions.navigateTo('website.list', {shownew:'yes'}))
                } }
              >
                Create Website
              </Button>
              <Typography gutterBottom variant="body1">
                You can change your tier at any time by visiting the "billing" section.
              </Typography>
              
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <AppsumoPlans />
        </Grid>
      </Grid>
    </div>
  )
}

export default Welcome